import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import styles from './video-gallery.css'
import Player from './player/player'
import Thumb from './thumb/thumb'

class VideoGallery extends PureComponent {
  static propTypes = {
    videos: PropTypes.array.isRequired,
    hasSidebar: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.state = {
      selected: props.videos[0],
    }
  }

  playerRef = React.createRef()

  onThumbClick = selected => {
    this.setState({ selected })
    this.playerRef.current.focus()
  }

  render() {
    const { selected } = this.state
    const { videos, hasSidebar } = this.props

    const containerClassName = hasSidebar
      ? `${styles['container']} ${styles['container--sidebar']}`
      : styles['container']

    if (videos.length === 0) return null

    return (
      <div className={containerClassName}>
        <Player
          url={selected.url}
          title={selected.title}
          thumbnail={selected.thumbnail}
          ref={this.playerRef}
        />
        {videos.length > 1 ? (
          <div className={styles['list__container']}>
            <ul className={styles['list']}>
              {videos.map(video => (
                <Thumb
                  onClick={this.onThumbClick}
                  key={video.id}
                  video={video}
                  selected={selected.id === video.id}
                  isFluid={hasSidebar}
                />
              ))}
            </ul>
          </div>
        ) : null}
      </div>
    )
  }
}

export default VideoGallery
